export default [
    {
        path: '/emcadmin/alert-messages',
        name: 'emcadmin-alert-messages',
        component: () => import ('./views/AlertMessagesIndex'),
        meta: {
            title: 'Mensagens de alerta do sistema',
            icon: 'mdi-alert',
            breadcrumbs: [
                { text: 'Lista de mensagens de alerta do sistema', disabled: true }
            ]
        }
    },
]
